<template>
  <v-layout>
    <v-flex xs12 md5>
      <v-card style="height: 550px; overflow-y: auto;">
        <v-card-text>
          <listOption
            :items.sync="comp_optionList"
            @searchText="searchText"
            @update_item="update_item"
            @update_all="update_all"
            @clear_search="clear_search"
          />
        </v-card-text>
      </v-card>
    </v-flex>
    
    <v-flex xs12 md7>
      <v-card style="height: 550px; overflow-y: auto;">
        <v-card-actions style="padding: 16px 16px 0px 16px;">
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="onClick_group(true)">
            <v-icon>add_circle</v-icon> Group
          </v-btn>
          <v-btn flat color="primary" @click="onClick_groupCopy" :disabled="panel==null || comp_showList.length == 0">
            <v-icon>file_copy</v-icon> Group {{ panel+1 }}
          </v-btn>
          <v-btn flat color="primary" @click="onClick_group(false)" :disabled="panel==null || comp_showList.length == 0">
            <v-icon>remove_circle</v-icon> Group
          </v-btn>
        </v-card-actions>

        <v-card-text>
          <v-expansion-panel v-model="panel" popout>
            <v-expansion-panel-content
              v-for="(i, idx) in comp_showList"
              :key="idx"
              :class="{ dull: panel === idx }"
            >
              <template v-slot:header>
                <div>GROUP {{ idx +1 }} ({{ i.length }} members)</div>
              </template>

              <ListShow
                :items.sync="i"
                @delete_item="delete_item"
                @update_role="update_role"
              />

            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-card-text>
      </v-card>

    </v-flex>
  </v-layout>
</template>


<script>
import ListOption from "./ListOption";
import ListShow from "./ListShow";
import common from "../functions/general";
import qb from "../functions/query.builder";

export default {
  name: "ListGroup_Member_BTRT",
  props: {
    // optionItems: {
    //   type: Array,
    //   required: true
    // },
    showItems: {
      type: Array,
      required: true
    },
    showItemsProp: {
      type: Array,
      required: true
    }
  },
  components: {
    ListOption: ListOption,
    ListShow: ListShow
  },
  data () {
    return {
      panel: 0,
      option_List: [],
      show_List: [],
      // show_List_prop: [],
      option_ListCache: []
    };
  },
  watch: {
    "showItems": {
      handler: function() {
        // this.show_List = [...this.showItems];
        this.show_List = structuredClone(this.showItems);
      },
      deep: true
    }
  },
  methods: {
    searchText (text) {
      let propertiesToSearch = ["emp__full_name", "emp__user__username", "dept__name", "dept__company__name"]
      let temp = this.option_ListCache.filter(item =>
        propertiesToSearch.some(prop =>
          item[prop] && item[prop].toLowerCase().includes(text.toLowerCase())
        )
      )
      this.option_List = temp;
    },
    clear_search () {
      this.option_List = this.option_ListCache;
    },
    get_arrIndex(arr, targetID) {
      // if (arr != undefined) {
      //   return arr.findIndex(obj => obj["id"] === targetID);
      // }
      return arr.findIndex(obj => obj["id"] === targetID);
    },
    mapObj(obj, objTarget) {
      var temp = obj.map(item=>{
        item["isSelected"] = false;
        
        if(objTarget != undefined){
          var found = objTarget.find(el=> el["id"]==item["id"]);
          if(found){
           item["isSelected"] = true;
          }
        }
        return item;
      });

      return temp;
    },
    delete_item (idx) {
      if (this.show_List[this.panel][idx].prop[0].value == true) {
        // do not allow to remove member with self-assessment true.
        common.wMsgBox.Error("Please reassign 'Self Assessment' candidate prior removal.");
      } else {
        this.show_List[this.panel].splice(idx,1);
        this.$emit("newList", this.show_List);
      }

    },
    update_role ({idx, role, role_idx}) {
      if (role.value) {
        // Note: must hv at least 1 self asmt member.
        common.wMsgBox.Info("Please reassign 'Self Assessment' candidate.");
        return;
      }

      this.show_List[this.panel].forEach(e => e.prop[role_idx].value = false);
      this.show_List[this.panel][idx].prop[role_idx].value = !role.value;
      // this.show_List[this.panel].forEach(e => e.prop[0].value = false);
      // this.show_List[this.panel][idx].prop[0].value = !item.prop[0].value;
      this.$emit("newList", this.show_List);
    },
    update_item (item) {
      if (this.panel == null) {
        common.wMsgBox.Info("Please select Group to update.");
        return;
      }
      
      if (this.show_List.length < 1) {
        common.wMsgBox.Info("Please add Group to update.");
        return;
      } 

      if (item.isSelected) {
        // delete member from list
        let idx1 = this.get_arrIndex(this.show_List[this.panel], item.id);
        if (this.show_List[this.panel][idx1].prop[0].value == true) {
          // do not allow to remove member with self-assessment true.
          common.wMsgBox.Error("Please reassign 'Self Assessment' candidate prior removal.");
        } else {
          this.show_List[this.panel].splice(idx1, 1);
        }
        // this.show_List[this.panel].splice(idx1, 1);

      } else {
        // add member to list
        if (this.show_List[this.panel].length > 0) {
          this.show_List[this.panel].push({
            comp: item.dept__company__name,
            dept: item.dept__name,
            id: item.id,
            name: item.emp__full_name,
            prop: structuredClone(this.showItemsProp),
            username: item.emp__user__username,
            email: "",
            _key: ""
          });
        } else {
          // default first member added as self-true.
          this.show_List[this.panel].push({
            comp: item.dept__company__name,
            dept: item.dept__name,
            id: item.id,
            name: item.emp__full_name,
            prop: [{
              g_role_id: this.showItemsProp[0].g_role_id,
              name: this.showItemsProp[0].name,
              value: true
            }],
            username: item.emp__user__username,
            email: "",
            _key: ""
          });
        }
      }

      this.$emit("newList", this.show_List);
    },
    update_all(bln) {
      if (this.panel == null) {
        return;
      }
      
      if (this.show_List[this.panel].length == 0) {
        this.option_List.forEach((e) => {
          let temp3 = {};
          temp3["username"] = e["emp__user__username"];
          temp3["name"] = e["emp__full_name"];
          temp3["prop"] = structuredClone(this.showItemsProp);
          temp3["id"] = e["id"];
          temp3["comp"] = e["dept__company__name"];
          temp3["dept"] = e["dept__name"];
          temp3["email"] = "";
          temp3["_key"] = "";

          this.show_List[this.panel].push(temp3);
        });
        // default first member with Self-true.
        this.show_List[this.panel][0].prop[0].value = true;

      } else {
        let lenK = this.option_List.length;
        for (let m = 0; m < lenK; m++) {
          var found = this.show_List[this.panel].find(el=> el.id == this.option_List[m].id);
        
          if (bln) {
            if (found == undefined) {
              let temp2 = {};
              temp2["username"] = this.option_List[m]["emp__user__username"];
              temp2["name"] = this.option_List[m]["emp__full_name"];
              // temp2["prop"] = this.show_List_prop;
              temp2["prop"] = structuredClone(this.showItemsProp);
              temp2["id"] = this.option_List[m]["id"];
              temp2["comp"] = this.option_List[m]["dept__company__name"];
              temp2["dept"] = this.option_List[m]["dept__name"];
              temp2["email"] = "";
              temp2["_key"] = "";
            
              this.show_List[this.panel].push(temp2);
            }
          } else {
            if (found) {
              let idx2 = this.get_arrIndex(this.show_List[this.panel], this.option_List[m].id);
            
              if (this.show_List[this.panel][idx2].prop[0].value == true) {
                // do not allow to remove member with self-assessment true.
                common.wMsgBox.Error("Please reassign 'Self Assessment' candidate prior removal.");
              } else {
                this.show_List[this.panel].splice(idx2,1);
              }
            }
          }
        }
      }
      this.$emit("newList", this.show_List);
    },
    onClick_group (bln) {
      if (bln) {
        this.show_List.push([]);
      } else {
        if (this.panel != null) {
          this.show_List.splice(this.panel,1);
        }
      }
      this.$emit("newList", this.show_List);
    },
    onClick_groupCopy () {
      this.show_List.push(structuredClone(this.show_List[this.panel]));
      this.$emit("newList", this.show_List);
    }
  },
  async mounted () {
		let cls_qb = new qb.QueryBuilder();
		cls_qb.Method = "all";
		cls_qb.Table = "emps_dept_employee";
		cls_qb.Select = [
			"id",
			"emp__user__username",
			"emp__full_name",
			"dept__name",
			"dept__company__name",
			"emp__user__email",
			"emp__email_p"
		];
		// var rule = new qb.Rule();
		// rule
		// 	.field("parent_company_id__name")
		// 	.operator(qb.STR_OPERATOR.I_CONTAINS)
		// 	.value("group");
		// cls_qb.addRule(rule);
		cls_qb.Order = ["emp__full_name"];
		var result = await common.wBackEndComm.PostData("process_qb/", cls_qb);
		if (result.data.Status == 1) {
			this.option_List = result.data.Body.records.map(item=>{
				item["isSelected"]=false;
				return item;
			});
      this.option_ListCache = [...this.option_List];
		} else {
			common.wMsgBox.Error(result.data.Description);
		}
  },
  computed: {
    comp_optionList: {
      get: function () {
        return this.mapObj(this.option_List, this.comp_showList[this.panel]);
        // return this.this.option_List;
      },
      set:function(val){
        
      }
    },
    comp_showList: {
      get: function () {
        // return this.showItems;
        return this.show_List;
      },
      set:function(val){
        // this.$emit("input",val);
      }
    }
  }
};
</script>